import { render } from "./ViewCorrectionQuestions.vue?vue&type=template&id=39b2b834&scoped=true"
import script from "./ViewCorrectionQuestions.vue?vue&type=script&lang=js"
export * from "./ViewCorrectionQuestions.vue?vue&type=script&lang=js"

import "./ViewCorrectionQuestions.vue?vue&type=style&index=0&id=39b2b834&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b2b834"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QInput,QCheckbox});
